import { useChips } from "@website/ui-old/chips/chips.hook";
import styles from "@website/ui-old/chips/chips.module.scss";
import { ChipsPropertiesType } from "@website/ui-old/chips/chips.types";
import { deepCompare } from "@website/utils/deep-compare";
import { FC, memo } from "react";

const Chips: FC<ChipsPropertiesType> = (properties) => {
  const {
    disabled,
    EndIcon,
    StartIcon,
    selected,
    variant,
    color,
    text,
    avatar,
    alt,
    datatestid
  } = properties;
  const { endIconProperties, rootProperties } = useChips(properties);

  return (
    <div
      {...rootProperties}
      className={`${styles["chips"]} ${styles[variant || "contained"]} ${
        styles[color || "primary"]
      } ${disabled ? styles["disabled"] : ""} ${
        selected ? styles["selected"] : ""
      }`}
      data-testid={datatestid}
    >
      {avatar ? (
        <img alt={alt} className={styles["image"]} src={avatar} />
      ) : StartIcon ? (
        <div className={styles["start-icon"]}>{StartIcon}</div>
      ) : null}
      <div className={styles["text"]}>{text}</div>
      {EndIcon ? (
        <div {...endIconProperties} className={styles["end-icon"]}>
          {EndIcon}
        </div>
      ) : null}
      <div className={styles["overlay"]} />
    </div>
  );
};

const ChipsMemoized = memo(Chips, deepCompare);
/**
 * @deprecated please use @website/ui instead
 */
export { ChipsMemoized /**
 * @deprecated please use @website/ui instead
 */ as Chips };
